<template>
  <div class="content-wrapper">
    <ContentHeader title="Заявки и счета" />
    <div class="content-body">
      <BillTable
        title="СПИСОК ЗАЯВОК"
        :topCaption="topCaption"
        :fields="fields"
        :items="getRequests"
        :busy="isRequestsLoading"
        :failed="isRequestsFailed"
        @reload="reloadRequests"
      >
        <template slot="top">
          <div class="card-block">
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group text-xs-right">
                  <button
                    class="btn btn-info btn-min-width bg-deep-purple bg-darken-1 btn-hover"
                    style="margin-left: 10px;"
                    @click="showModal = true"
                  >
                    <i class="icon-list-ul" style="padding-right: 10px;"></i> Запросить акт-сверки
                  </button>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:cell(status)="data">
          <span
            class="tag tag-default"
            :class="{ 
                    'bg-warning bg-red bg-darken-2': data.value === 'Принята',
                    'bg-warning bg-darken-3': data.value === 'Обрабатывается',
                    'bg-green bg-darken-1': data.value === 'Выполнена',
                  }"
          >{{ data.value }}</span>
        </template>
        <template v-slot:cell(bill_number)="data">
          <a
            v-if="data.value"
            @click="printBill(data.item.bill_id)"
            class="btn-link"
            style="color: #004a8e;white-space: nowrap;"
          >
            <i class="icon-file-pdf"></i>
            {{ data.value }}
          </a>
        </template>
      </BillTable>
    </div>
    <modal :id="modalId" v-if="showModal" @close="closeModal" @cancel="closeModal" @ok="requestAct">
      <template slot="header-title">ЗАПРОСИТЬ АКТ-СВЕРКИ</template>
      <template slot="body">
        <p>Для отправки запроса укажите за какой период Вам нужен акт-сверки и на какой e-mail Вам его отправить.</p>
        <div class="form-group">
          <input type="text" placeholder="Укажите период" class="form-control" v-model="actPeriod" />
        </div>
        <div class="form-group">
          <input type="email" placeholder="Укажите e-mail" class="form-control" v-model="actEmail" />
        </div>
      </template>
      <template slot="ok-title">Отправить запрос</template>
    </modal>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";
import BillTable from "@/components/BillTable";
import modal from "@/components/modal.vue";
import { mapGetters } from "vuex";
import { requestFields } from "@/fields.js";
import {
  REQUESTS_REQUEST,
  REQUESTS_ADD_REQUEST,
} from "@/store/actions/requests";
import { BILLS_REQUEST } from "@/store/actions/bills";
import pdfMake from "@/utils/pdfmake.min.js";
import pdfFonts from "@/utils/vfs_fonts.min.js";

export default {
  name: "Requests",
  components: {
    ContentHeader,
    BillTable,
    modal,
  },
  data() {
    return {
      fields: requestFields,
      modalId: "modal",
      showModal: false,
      actPeriod: null,
      actEmail: null,
    };
  },
  computed: {
    ...mapGetters([
      "getRequests",
      "getRequestsCount",
      "isRequestsLoading",
      "isRequestsFailed",
      "requestsOnceLoaded",

      "getBills",
      "getBillById",
      "billsOnceLoaded",
    ]),
    topCaption() {
      return null; //`Всего заявок - ${this.getRequestsCount}`;
    },
  },
  methods: {
    printBill(id) {
      let bill = this.getBillById(id);
      let b = bill.body;

      pdfMake.vfs = pdfFonts.pdfMake.vfs;

      let billName = `Счет на оплату № ${bill.number || "Ошибка"} от ${
        bill.date
          ? new Date(bill.date).toLocaleDateString("default", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })
          : "Ошибка"
      }`;
      let dd = {
        content: [
          {
            columns: [
              {
                width: 100,
                fontSize: 9,
                text: "",
              },
              [
                {
                  text: [
                    "Внимание! Оплата данного счета означает согласие с условиями поставки товара. ",
                    "Уведомление об оплате обязательно, в противном случае не гарантируется наличие товара на складе. ",
                    "Товар отпускается по факту  прихода денег на р/с Поставщика, самовывозом, ",
                    "при наличии доверенности и документов удостоверяющих личность.",
                  ],
                  fontSize: 8,
                  alignment: "center",
                },
              ],
            ],
          },
          {
            text: " ",
            fontSize: 8,
            lineHeight: 2,
          },
          {
            text: "Образец платежного поручения",
            fontSize: 10,
            bold: true,
          },
          {
            table: {
              widths: ["*", "*", "auto"],
              body: [
                [
                  {
                    text: "Бенефициар:",
                    bold: true,
                    border: [true, true, true, false],
                  },
                  {
                    text: "ИИК",
                    bold: true,
                    alignment: "center",
                    border: [true, true, true, false],
                  },
                  {
                    text: "Кбе",
                    bold: true,
                    alignment: "center",
                    border: [true, true, true, false],
                  },
                ],
                [
                  {
                    text: b.beneficiary_name || "Ошибка",
                    bold: true,
                    border: [true, false, true, false],
                  },
                  {
                    text: b.iik || "Ошибка",
                    rowSpan: 2,
                    bold: true,
                    alignment: "center",
                    border: [true, false, true, true],
                  },
                  {
                    text: b.kbe || "Ошибка",
                    rowSpan: 2,
                    bold: true,
                    alignment: "center",
                    border: [true, false, true, true],
                  },
                ],
                [
                  {
                    text: `БИН: ${b.beneficiary_bin || "Ошибка"}`,
                    border: [true, false, true, true],
                  },
                  "",
                  "",
                ],
                [
                  {
                    text: "Банк бенефициара:",
                    border: [true, true, true, false],
                  },
                  {
                    text: "БИК",
                    bold: true,
                    alignment: "center",
                    border: [true, true, true, false],
                  },
                  {
                    text: "Код назначения платежа",
                    bold: true,
                    alignment: "center",
                    border: [true, true, true, false],
                  },
                ],
                [
                  {
                    text: b.beneficiary_bank || "Ошибка",
                    border: [true, false, true, true],
                  },
                  {
                    text: b.bik || "Ошибка",
                    bold: true,
                    alignment: "center",
                    border: [true, false, true, true],
                  },
                  {
                    text: b.payment_code || "Ошибка",
                    bold: true,
                    alignment: "center",
                    border: [true, false, true, true],
                  },
                ],
              ],
            },
          },
          {
            text: " ",
            fontSize: 8,
            lineHeight: 2,
          },
          {
            text: billName,
            fontSize: 14,
            bold: true,
          },
          {
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    text: "",
                    fontSize: 1,
                    border: [false, false, false, true],
                  },
                ],
              ],
            },

            layout: {
              hLineWidth: function () {
                return 3;
              },
            },
          },
          { text: " ", fontSize: 4 },
          {
            table: {
              widths: ["auto", "*"],
              body: [
                [
                  "Поставщик:",
                  {
                    text: b.supplier || "Ошибка",
                    bold: true,
                  },
                ],
                [
                  "Покупатель:",
                  {
                    text: b.buyer || "Ошибка",
                    bold: true,
                  },
                ],
                [
                  "Договор:",
                  {
                    text: b.doc || "Ошибка",
                    bold: true,
                  },
                ],
              ],
            },
            layout: "noBorders",
          },
          { text: " ", fontSize: 4 },
          {
            style: "tableExample",
            table: {
              widths: ["auto", "auto", "*", "auto", "auto", "auto", "auto"],
              headerRows: 1,
              body: [
                [
                  { text: "№", style: "tableHeader" },
                  { text: "Код", style: "tableHeader" },
                  { text: "Наименование", style: "tableHeader" },
                  { text: "Кол-во", style: "tableHeader" },
                  { text: "Ед.", style: "tableHeader" },
                  { text: "Цена", style: "tableHeader" },
                  { text: "Сумма", style: "tableHeader" },
                ],
              ].concat(
                b.products
                  ? b.products.map((v) => {
                      return [
                        v.num,
                        v.code,
                        v.name,
                        v.quantity,
                        v.units,
                        v.price,
                        v.sum,
                      ];
                    })
                  : []
              ),
            },
            layout: {
              hLineWidth: function (i, node) {
                return i === 0 || i === node.table.body.length ? 3 : 1;
              },
              vLineWidth: function (i, node) {
                return i === 0 || i === node.table.widths.length ? 3 : 1;
              },
            },
          },
          { text: " ", fontSize: 4 },
          {
            table: {
              widths: ["*", "auto"],
              body: [
                [
                  { text: "Итого:", bold: true, alignment: "right" },
                  { text: b.total || "Ошибка", bold: true, alignment: "right" },
                ],
                [
                  { text: "В том числе НДС:", bold: true, alignment: "right" },
                  { text: b.vat || "Ошибка", bold: true, alignment: "right" },
                ],
              ],
            },
            layout: "noBorders",
          },
          {
            text: `Всего наименований ${
              b.products ? b.products.length : "Ошибка"
            }, на сумму ${b.total || "Ошибка"} ${b.currency || "Ошибка"}`,
          },
          {
            text: `Всего к оплате: ${b.total_string}`,
            bold: true,
          },
          {
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    text: "",
                    fontSize: 1,
                    border: [false, false, false, true],
                  },
                ],
              ],
            },

            layout: {
              hLineWidth: function () {
                return 3;
              },
            },
          },
          { text: " ", fontSize: 4 },
          {
            table: {
              widths: ["auto", "*", "auto", 150],
              body: [
                [
                  {
                    text: "Исполнитель",
                    bold: true,
                    border: [false, false, false, false],
                  },
                  { text: "", border: [false, false, false, true] },
                  {
                    text: `/${b.executor || "Ошибка"}/`,
                    fontSize: 8,
                    border: [false, false, false, false],
                  },
                  { text: "", border: [false, false, false, false] },
                ],
              ],
            },
          },
        ],
        styles: {
          tableHeader: {
            bold: true,
            color: "black",
            alignment: "center",
          },
        },
        defaultStyle: {
          fontSize: 9,
        },
      };

      pdfMake.createPdf(dd).download(billName.replace(".", ""));
    },
    closeModal() {
      this.showModal = false;
      this.actPeriod = null;
      this.actEmail = null;
    },
    requestAct() {
      let body = JSON.stringify({
        products: [
          {
            type: "reconciliation_act",
            name: `Акт сверки на e-mail ${this.actEmail} за период: ${this.actPeriod}`,
          },
        ],
      });
      this.$store.dispatch(REQUESTS_ADD_REQUEST, { body }).then(() => {
        this.closeModal();
      });
    },
    reloadRequests() {
      this.$store.dispatch(REQUESTS_REQUEST);
    },
  },
  created() {
    if (!this.requestsOnceLoaded) this.$store.dispatch(REQUESTS_REQUEST);
    if (!this.billsOnceLoaded) this.$store.dispatch(BILLS_REQUEST);
  },
};
</script>